import { FeatureFlags, FeatureFlagsConfig } from './types';

export const FEATURE_FLAGS: FeatureFlagsConfig = {
  [FeatureFlags.NOTIFICATION_CENTER]: true,
  [FeatureFlags.RESEND_INVITATION_EMAIL]: 'stg',
};
